module.exports = __webpack_public_path__ + "img/live-chat.dc2c85ee.svg";